<div id="kt_app_toolbar_container" class="container-fluid d-flex flex-stack p-0">
	<div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
		<h1 class="page-heading d-flex text-gray-900 fw-bold fs-3 flex-column justify-content-center my-0">
			{{ navTitle }}
		</h1>
		<ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
			<li class="breadcrumb-item text-muted">
				<a routerLink="/dashboard" class="text-muted text-hover-primary">Home</a>
			</li>
			<ng-container *ngFor="let breadcrumb of breadcrumbs; let last = last">
				<li class="breadcrumb-item">
					<span class="bullet bg-gray-500 w-5px h-2px mx-2"></span>
				</li>
				<li class="breadcrumb-item text-muted">
					<ng-container *ngIf="!last">
						<a [routerLink]="breadcrumb.url" class="text-muted text-hover-primary">{{ breadcrumb.label }}</a>
					</ng-container>
					<ng-container *ngIf="last">
						{{ breadcrumb.label }}
					</ng-container>
				</li>
			</ng-container>
		</ul>
	</div>

	<div class="d-flex align-items-center gap-2 gap-lg-3">
		<a *ngFor="let link of actionLinks" [routerLink]="link.url" routerLinkActive="bg-dark text-white" [routerLinkActiveOptions]="{ exact: true }" class="btn btn-outline btn-outline-dark btn-sm me-2">
			{{ link.title }}
		</a>
		<!-- <a href="#" class="btn btn-sm fw-bold btn-secondary" data-bs-toggle="modal" data-bs-target="#kt_modal_create_app">Rollover</a>
		<a href="#" class="btn btn-sm fw-bold btn-primary" data-bs-toggle="modal" data-bs-target="#kt_modal_new_target">Add Target</a> -->
	</div>
</div>